import { render, staticRenderFns } from "./MedicionAusentismoPagination.vue?vue&type=template&id=381e27c6&"
import script from "./MedicionAusentismoPagination.vue?vue&type=script&lang=js&"
export * from "./MedicionAusentismoPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports